module.exports = __webpack_public_path__ + "static/media/noun-sticker-1070910-142350.7968aba9.svg";